function getNodeindex(el) {
  return [...el.parentNode.children].indexOf(el)
}

function isInViewport(element, strict, options = {}) {
  const rect = element.getBoundingClientRect()
  const height = window.innerHeight || document.documentElement.clientHeight
  const width = window.innerWidth || document.documentElement.clientWidth
  const offset = { left: 0, right: 0, top: 0, bottom: 0, ...options }

  // All 4 corners should be in viewport, or center
  if (strict == 'center') {
    return (
      rect.right >= -offset.left &&
      rect.bottom >= -offset.top &&
      rect.left <= width + offset.right &&
      rect.top <= height / 2 + offset.bottom
    )
  } else if (strict == true) {
    return (
      rect.top >= -offset.top &&
      rect.left >= -offset.left &&
      rect.bottom <= height + offset.bottom &&
      rect.right <= width + offset.right
    )
  }

  // At least 1 corner is in viewport
  return (
    rect.right >= -offset.left &&
    rect.bottom >= -offset.top &&
    rect.left <= width + offset.right &&
    rect.top <= height + offset.bottom
  )
}

function scrollToEl(el, offset) {
  offset = offset || 0
  const y = el.getBoundingClientRect().top + window.pageYOffset + offset
  window.scrollTo({ top: y, behavior: 'smooth' })
}

function scrollToTop() {
  window.scrollTo({ top: 0, behavior: 'smooth' })
}

function getCookie(name) {
  const value = `; ${document.cookie}`
  const parts = value.split(`; ${name}=`)
  if (parts.length === 2) return parts.pop().split(';').shift()
}

async function waitUntil(predicate, { interval = 100, retries = 10 }) {
  let counter = 0
  const poll = (resolve, reject) => {
    if (counter >= retries) {
      reject()
    } else if (predicate()) {
      resolve()
    } else {
      counter += 1
      setTimeout(() => poll(resolve, reject), interval)
    }
  }
  return new Promise(poll)
}

export {
  getNodeindex,
  isInViewport,
  scrollToEl,
  scrollToTop,
  getCookie,
  waitUntil,
}
export { default as Validator } from './validator'
export * from './sampleData'
